export enum FEATURES_TYPE {
    list = 'LIST',
    str = 'STRING',
    bol = 'BOOLEAN',
    number = 'NUMBER',
}